import { createAccount, updateAssignRole } from "SuperAdmin/Services/Account";
import { Form, message } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./AccountCreate.module.scss";
import FormCreate from "./Components/Form/Form";
import UploadImage from "./Components/UploadImage/UploadImage";
import { handleAPIResponse } from "SuperAdmin/Utils/HandleAPIResponse";
const AccountCreate = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const mappedProfileID = Form.useWatch("mapped_profile_id", form);
  const name = Form.useWatch("name", form);
  const email = Form.useWatch("email", form);
  const institutionId = Form.useWatch("institution_id", form);
  const department = Form.useWatch("department", form);
  const activate = Form.useWatch("activate", form);
  const role = Form.useWatch("role", form);
  const [addedRole, setAddedRole] = useState(null);
  useEffect(() => {
    form.setFieldsValue({
      role: [
        {
          type: 3,
          name: "",
          institution: "",
          position: "",
        },
      ],
      activate: 1,
    });
  }, []);
  const onFinishForm = () => {
    const payload = {
      email: email,
      name: name,
      institution_id: institutionId,
      mapped_profile_id: mappedProfileID,
      activate: activate == 1 ? true : false,
      department: department,
    };
    createAccount(payload, (res) => {
      if (res.detail) {
        message.error(res.detail);
      } else {
        handleAPIResponse(res, () => {
          if (addedRole) {
            updateAssignRole(res.data.id, addedRole.id, (response) => {
              if (response.status == "OK") {
                setTimeout(() => {
                  message.success(
                    "Create account and assign role successfully"
                  );
                }, 1500);
                navigate("/super-admin/accounts");
              }
            });
          } else {
            setTimeout(() => {
              message.success("Create account successfully");
            }, 1500);
            navigate("/super-admin/accounts");
          }
        });
      }
    });
  };
  return (
    <div className={styles["account-create"]}>
      <div className={styles["image"]}>
        <UploadImage form={form} />
      </div>
      <FormCreate
        form={form}
        mappedProfileID={mappedProfileID}
        onFinishForm={onFinishForm}
        role={role}
        addedRole={addedRole}
        setAddedRole={setAddedRole}
      />
    </div>
  );
};

export default AccountCreate;
